import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import { paginatedApiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { forumPostSchema } from './schemas';

export const forumUserPostsQueryOptions = (userId: number) =>
  infiniteQueryOptions({
    queryKey: QueryKeys.forum.index.user(userId),
    queryFn: async ({ pageParam }) => {
      const response = await fetchJson('/forum/posts', {
        schema: paginatedApiResourceSchema(forumPostSchema.array()),
        params: {
          userId,
          pagination: { pageIndex: pageParam, pageSize: 20 },
        },
      });

      return response;
    },
    getNextPageParam: (lastPage) => lastPage.pagination.nextPage,
    initialPageParam: 1,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

export const useForumUserPosts = (userId: number) => useInfiniteQuery(forumUserPostsQueryOptions(userId));
